import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-add-student-modal',
    templateUrl: './add-student-modal.component.html',
    imports: [
        MatDialogModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule
    ]
})
export class AddStudentModalComponent implements OnInit {
    protected readonly dialogRef = inject(MatDialogRef<AddStudentModalComponent>);
    protected readonly data: { availableStudents: string[] } = inject(MAT_DIALOG_DATA);
    studentForm: FormGroup;

    ngOnInit() {
        this.studentForm = new FormGroup({
            studentID: new FormControl('', Validators.required)
        });
    }

    closeDialog() {
        this.dialogRef.close(null);
    }

    submit(form: FormGroup) {
        if (form.invalid) {
            return;
        }

        if (!this.data.availableStudents.includes(form.value.studentID)) {
            form.get('studentID').setErrors({ invalid: true });
            return;
        }

        this.dialogRef.close(form.value.studentID);
    }
}
